import { useTask } from '@/ui/concerns';
import { paymentSourceUpdated } from '@/services/api/resources/chargebee/product/actions';

export const paymentSourceUpdatedTask = useTask(
  () => paymentSourceUpdated(),
  response => response,
);
